module.exports = __webpack_public_path__ + "img/bnr-survey.c6fd2820.png";